module.exports = __webpack_public_path__ + "static/media/icon-app-store.11706272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-app-store.png
// module id = 403
// module chunks = 0